
import Home from "./Screens/home/Home";

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
